import { generateSalePercentageBasedOnType } from 'utils';
import srcSaleBadge from 'assets/SpinX/sale-badge-ch.png';
import { ESaleDiscountDisplayType } from 'utils/enums';
import { StyledCashFrenzySaleBadge } from './styles';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { SaleBadgeProps } from '../../types';

export const CashFrenzySaleBadge = ({
  salePercentage,
  salePercentageDisplayType = ESaleDiscountDisplayType.PERCENTAGE,
}: SaleBadgeProps) => {
  return (
    <StyledCashFrenzySaleBadge>
      <img src={srcSaleBadge} alt="sale-badge" />
      <div className="spinx-container">
        <AutoTextSize
          as="div"
          mode="oneline"
          maxFontSizePx={16}
          minFontSizePx={4}
          className="number"
        >
          {generateSalePercentageBasedOnType(
            salePercentage,
            salePercentageDisplayType,
          )}
        </AutoTextSize>
        <div className="sale-text">SALE</div>
      </div>
    </StyledCashFrenzySaleBadge>
  );
};
